import { render, staticRenderFns } from "./SellingCompanyDetails.vue?vue&type=template&id=45cc5dbe&"
import script from "./SellingCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./SellingCompanyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports